import * as ECGConstants from '../constants/ECGs';

const initialState = {
  isFetching: false,
  isLoaded: false,
  isMarkingAsSeen: false,
  model: {}
};

export function ecgDetail(state = initialState, action) {
  switch (action.type) {
    case ECGConstants.FETCH_DETAIL_STARTED:
      return Object.assign({}, state, {isFetching: true, isLoaded: false, model: initialState.model});
    case ECGConstants.FETCH_DETAIL_COMPLETED:
      return Object.assign({}, state, {isFetching: false, isLoaded: true, model: action.ecg});
    case ECGConstants.MARK_SEEN_STARTED:
      return Object.assign({}, state, {isMarkingAsSeen: true});
    case ECGConstants.MARK_SEEN_COMPLETED: {
      const newModel = Object.assign({}, state.model, {seenAt: action.seenAt, seenBy: action.seenBy});

      return Object.assign({}, state, {isMarkingAsSeen: false, model: newModel});
    }
    default:
      return state;
  }
}
